export default __webpack_public_path__ + "static/media/wondering.c5f563e9.svg";